import type { Components } from 'react-markdown';

// No rehype-raw (so no raw HTML) and images are disabled — a rendered image URL in model
// output would be an exfiltration channel. Everything else is styled for the narrow chat panel:
// tables scroll horizontally, lists/paragraphs get compact spacing, links open sandboxed.
export const chatMarkdownComponents: Components = {
  img: () => null,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer nofollow" className="text-blue underline">
      {children}
    </a>
  ),
  p: ({ children }) => <p className="mb-3 leading-6 last:mb-0">{children}</p>,
  ul: ({ children }) => <ul className="mb-3 list-disc space-y-1.5 pl-5 last:mb-0">{children}</ul>,
  ol: ({ children }) => <ol className="mb-3 list-decimal space-y-1.5 pl-5 last:mb-0">{children}</ol>,
  li: ({ children }) => <li className="leading-6">{children}</li>,
  strong: ({ children }) => <strong className="font-semibold text-grey90">{children}</strong>,
  h1: ({ children }) => <h3 className="mt-4 mb-2 font-semibold first:mt-0">{children}</h3>,
  h2: ({ children }) => <h3 className="mt-4 mb-2 font-semibold first:mt-0">{children}</h3>,
  h3: ({ children }) => <h4 className="mt-4 mb-1.5 font-semibold first:mt-0">{children}</h4>,
  code: ({ children }) => <code className="rounded bg-grey20 px-1 py-0.5 font-mono text-xs">{children}</code>,
  pre: ({ children }) => <pre className="mb-2 overflow-x-auto rounded-lg bg-grey20 p-2 text-xs">{children}</pre>,
  table: ({ children }) => (
    <div className="my-2 overflow-x-auto">
      <table className="w-full border-collapse text-xs">{children}</table>
    </div>
  ),
  th: ({ children }) => <th className="border-b border-grey30 px-2 py-1 text-left font-semibold">{children}</th>,
  td: ({ children }) => <td className="border-b border-grey25 px-2 py-1 align-top">{children}</td>,
};
